export default __webpack_public_path__ + "static/media/opcint.29c70e69.svg";